import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../styles/SubscriptionContainer.module.scss';
import { usePurchaseSubscriptionContext } from '../../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import Button from '../../../../components/Button';
import { gqlTypes } from '../../../../types';
import { maybeTruncatePetName } from '../util/helpers';
import SubscriptionAppBar from '../../components/SubscriptionAppBar';
import checkMarkImage from '../../../../assets/images/in_app_cancellation/check_mark_confetti.gif';
import checkMarkBackground from '../../../../assets/images/in_app_cancellation/check_mark_background.png';
import { inAppCancellation as events } from '../../../../lib/analytics/events';

export default function KeepMembershipConfirmation() {
  const { t } = useTranslation();
  const { device } = usePurchaseSubscriptionContext();
  if (!device.pet) {
    throw new Error('No pet found.');
  }
  if (!device.subscription?.id) {
    throw new Error('No recurly subscription found.');
  }

  const petName = device.pet.name ? device.pet.name : t('your_dog');
  const shortPetName = maybeTruncatePetName(petName);
  const petPronoun = device.pet.gender === gqlTypes.Gender.MALE ? t('his') : t('her');
  const petAvatarPath = device.pet.photos.first?.image?.fullSize;

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBar
          backButtonAnalyticsEvent={() => events.keepMembershipConfirmationBack({ petId: device.pet?.id })}
          closeButtonAnalyticsEvent={() => events.keepMembershipConfirmationClose({ petId: device.pet?.id })}
        />
        <div className={styles.subscriptionContainer}>
          <h1>{t('were_glad_you_and_pet_name_are_sticking_with_fi', { petName: shortPetName })}</h1>

          <div className={styles.content}>
            <p>
              {t(
                'congratulate_yourself_for_being_the_best_dog_parent_possible_by_staying_invested_in_pet_name_long_term_health',
                {
                  petName,
                },
              )}
            </p>
            <p>
              {t(
                'you_let_pet_name_keep_doing_pronoun_thing_and_well_continue_delivering_the_data_you_need_to_stay_a_step_ahead',
                {
                  petName,
                  pronoun: petPronoun,
                },
              )}
            </p>

            {petAvatarPath && (
              <>
                <div className={styles.keepMembershipPetImage}>
                  <div className={styles.keepMembershipPetImages}>
                    <div className={styles.keepMembershipPetImageAvatar}>
                      <img src={petAvatarPath} alt={petName} />
                    </div>
                    <div className={styles.keepMembershipPetImageCheckMarkBackground}>
                      <img src={checkMarkBackground} alt={t('check_mark')} />
                    </div>
                    <div className={styles.keepMembershipPetImageCheckMark}>
                      <img src={checkMarkImage} alt={t('check_mark')} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            className={styles.button}
            onClick={() => {
              window.open('fi://closeappview');
            }}
          >
            {t('done')}
          </Button>
          {/* Spacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
